"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDictionary = void 0;
const ramda_1 = require("ramda");
/**
 * Map dictionary keys into a new values
 * @public
 *
 * @param mapper - Function to be applied to each root key
 * @param input - The dictionary to be transformed
 *
 * @returns A new dictionary with same keys but different values
 *
 * @example
 * ```ts
 * const config: = {
 *  key: 'value',
 *  key2: 'value2',
 * }
 * const result = mapDictionary(
 *   (value, key) => key.toUpperCase(),
 *   config
 * );
 * console.log(result);
 * // -> {
 * //   key: 'KEY',
 * //   key2: 'KEY2',
 * // }
 * ```
 */
function mapDictionary(mapper, input) {
    return (0, ramda_1.pipe)((0, ramda_1.mergeDeepLeft)({}), (0, ramda_1.mapObjIndexed)(mapper))(input);
}
exports.mapDictionary = mapDictionary;
//# sourceMappingURL=map-dictionary.js.map